import React from 'react';
import { Form, Input, Tooltip, FormInstance, FormProps, InputNumber,Switch } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import CancelButton from '../common/cancelbutton';
import FormButton from '../common/formbutton';
import SortableFormList from '../common/sortableformlist';


export interface RecipeItemFormProps {
  form: FormInstance;
  onValuesChange?: FormProps['onValuesChange'];
  onCancel?: () => void;
  onSave?: (values: any) => Promise<void>;
}

const RecipeItemForm: React.FC<RecipeItemFormProps> = ({
  form,
  onValuesChange,
  onCancel,
  onSave,
}) => {
  const handleValidateAndSave = async () => {
    form
      .validateFields()
      .then(async (values) => {
        await onSave?.(values);
      })
      .catch((err) => {
        console.log('validation failed:', err);
      });
  };

  return (
    <Form
      form={form}
      colon
      layout="vertical"
      onValuesChange={onValuesChange}
      initialValues={{fryer: true}}
    >
      <Tooltip title={form.getFieldValue('imageName')} placement="bottomRight">
        <Form.Item name="imageName" label="Image Url">
          <Input prefix={<LinkOutlined />} />
        </Form.Item>
      </Tooltip>

      <Form.Item label="Fryer" name="fryer" valuePropName="checked" >
                    <Switch
                        style={{ width: '50px' }}
                        checkedChildren="Yes"
                        unCheckedChildren="No"
                    />
      </Form.Item>
      {/* <Form.Item
        label="KDS Instructions"
        name="recipeKdsInstructions"
        extra="KDS instructions will display below the item name on the KDS"
      >
        <Input.TextArea
          placeholder="Enter KDS Instructions"
          allowClear
          autoSize={{ minRows: 1, maxRows: 6 }}
        />
      </Form.Item> */}
      <SortableFormList
        name="recipeKdsInstructions"
        label="KDS Instructions"
        placeholder="Enter instruction"
        fieldKey="instruction"
        form={form}
        alternateName="Instruction"
        maxLength={30}
        tooltipText="KDS instructions will display below the item name on the KDS"
        extra="These instructions will display below the item name on the KDS"
      />

      <Form.Item label="Current Quantity" name="quantity">
        <InputNumber style={{ width: '100%' }} disabled />
      </Form.Item>

      <Form.Item
        name="customQuantity"
        label="Quantity (Customised)"
        rules={[
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve(); // optional

              // Regex: digits with optional decimal part up to 2 places
              const regex = /^\d+(\.\d{1,2})?$/;
              if (!regex.test(value)) {
                return Promise.reject(new Error('Enter a valid number (up to 2 decimals)'));
              }

              const num = parseFloat(value);
              if (num < 0) return Promise.reject(new Error('Quantity cannot be negative'));
              if (num > 9999) return Promise.reject(new Error('Enter a valid quantity (0–9999)'));

              return Promise.resolve();
            },
          },
        ]}
      >
        <Input
          style={{ width: '100%' }}
          allowClear
          placeholder="Enter customised quantity"
        />
      </Form.Item>

      <Form.Item label="Current Unit of Measure" name="measure">
        <Input disabled />
      </Form.Item>

      <Form.Item
        name="customMeasure"
        label="Unit of Measure (Customised)"
        extra="Adjusting Quantities and Units of Measure will override what is shown on the KDS"
      >
        <Input style={{ width: '100%' }} allowClear placeholder="Enter customised unit of measure" />
      </Form.Item>

      <div style={{ textAlign: 'right' }}>
        <CancelButton onClick={() => onCancel?.()} />
        <FormButton title="Save" onClick={handleValidateAndSave} />
      </div>
    </Form>
  );
};

export default RecipeItemForm;